
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/youtube-privacy-policy",
      function () {
        return require("private-next-pages/youtube-privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/youtube-privacy-policy"])
      });
    }
  